let navigationLanguage = () => {

    let module = {},

        init = () => {
          $('.language-region-item a[data-toggle="collapse"]').click(function(e){
            if ($(window).width() >= 992) {
              e.stopPropagation();
              e.preventDefault();
            }
          });

        };

    module.init = init;

    return module;

};

export default navigationLanguage();